import React, {useState} from "react"
import { Typography, Container, Grid, Card, CardContent, Button, Box } from "@material-ui/core";
import Icon1 from "../../assets/images/IconImg2.png";
import Icon2 from "../../assets/images/ResourceIcons/R_Img2.png";
import Icon3 from "../../assets/images/ResourceIcons/R_Img3.png";
import Icon4 from "../../assets/images/ResourceIcons/R_Img4.png";
import Icon5 from "../../assets/images/ResourceIcons/R_Img5.png";
import Icon6 from "../../assets/images/ResourceIcons/R_Img6.png";
import Icon7 from "../../assets/images/ResourceIcons/R_Img7.png";
import Icon8 from "../../assets/images/ResourceIcons/R_Img8.png";
import {makeStyles} from "@material-ui/core/styles";
import {
    ApiIntegration,
    ContentVideos,
    EducationMaterial
} from "../../ui_library/ver_24.10/ResourcesDialogs/ResourcesDialogs.comp";

const useStyles = makeStyles({
    button: {
        backgroundColor: "white",
        color: "#ef6528",
        width:'95%',
        border: "2px solid #ef6528",
        marginTop: "auto",
        boxShadow:'none',
        '&:hover': {
            backgroundColor: '#ef6528',
            color:'#fff',
        },
    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        marginBottom: '20px !important',
        marginTop: '20px',
        fontSize: '35px',
    },
    card: {
        height: "320px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign:'center',
        justifyContent: "flex-start",
        borderBottomLeftRadius: "10px",
        borderBottomRightRadius: "10px",
        backgroundColor: "#fff",
        paddingTop:'10px',
        boxShadow:'none',
    },
    cardHeader: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingTop: '20px',
        height: '145px',
        borderRadius: '10% 10% 150% 150%/10% 10% 40% 40%',
        background: '#fff',

    },
    disabledCard: {
        backgroundColor: "#d8d8d8",
    },
    header: {
        textAlign: "center",
        color: "white",
        position: "relative",
        padding: "10px 0",
    },
    upgradeTag: {
        position: "absolute",
        top: "10px",
        right: "10px",
        backgroundColor: "#002060",
        color: "white",
        padding: "5px 10px",
        borderRadius: "5px",
        fontSize: "12px",
    },
    icon: {
        width: "45px",
        height: "40px",
        marginBottom: "10px",
    },
    cardContent: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        flexGrow: 1,
        padding:'0px',
    },
});
const ProgramResources = ({data, options, actions}) => {
    const {} = data;
    const {generatePPTFromModules} = actions;
    const {} = options;
    const classes = useStyles();
    const [openApiIntegration, setOpenApiIntegration] = useState(false);
    const [openEducationMaterial, setOpenEducationMaterial] = useState(false);
    const [openContentVideos, setOpenContentVideos] = useState(false);

    // Handle button click to open ApiIntegration dialog
    const handleOpenApiIntegration = () => {
        setOpenApiIntegration(true);
    };

    // Handle closing ApiIntegration dialog
    const handleCloseApiIntegration = () => {
        setOpenApiIntegration(false);
    };

    // Handle button click to open EducationMaterial dialog
    const handleOpenEducationMaterial = () => {
        setOpenEducationMaterial(true);
    };

    // Handle closing EducationMaterial dialog
    const handleCloseEducationMaterial = () => {
        setOpenEducationMaterial(false);
    };

    // Handle button click to open ContentVideos dialog
    const handleOpenContentVideos = () => {
        setOpenContentVideos(true);
    };

    // Handle closing ContentVideos dialog
    const handleCloseContentVideos = () => {
        setOpenContentVideos(false);
    };

    return (
        <>
            <Typography className={classes.title} variant="h1" style={{ fontWeight: 'bold', marginTop: '25px', textAlign: 'center' }}>
                Here’s your Program Resources!
            </Typography>

        <Container p={0} style={{ width:'80%',height: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Grid container spacing={3} style={{ backgroundColor: 'transparent', maxWidth: '90%' }}>
                <Grid item style={{ backgroundColor: '#fff', maxWidth: '49%', padding: '10px' }}>
                    <Typography
                        variant="h6"
                        style={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                            display: 'inline-block',
                            padding: '5px 15px',
                            width: '100%',
                            background: 'linear-gradient(to right, #6A8EC9 0%, #3CC6F3 100%)',
                            color: 'white',
                            borderRadius: '0px 0px 50px 50px',
                        }}
                    >
                        Technical
                    </Typography>
                    <Grid container spacing={1}>
                        <Grid item xs={6} p={0}>
                            <Card className={classes.card}>
                                <CardContent className={classes.cardContent}>
                                    <div className={classes.cardHeader} style={{ background: 'linear-gradient(to right, #6A8EC9 0%, #3CC6F3 100%)' }}>
                                        <img src={Icon1} className={classes.icon} alt="DQ Assessment" />
                                        <Typography variant="h6" style={{ height: '75px', color: '#fff', lineHeight: '1.1', fontWeight: 'bold' }}>
                                            Online Program
                                        </Typography>
                                    </div>
                                    <Typography variant="body1" style={{ color: '#474747', fontSize: '14px', padding: '0 50px', marginTop: '15px' }}>
                                        Your program’s website link that learners can access immediately
                                    </Typography>
                                    <Button variant="contained" className={classes.button}>
                                        Copy Link
                                    </Button>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6} p={0}>
                            <Card className={classes.card}>
                                <CardContent className={classes.cardContent}>
                                    <div className={classes.cardHeader} style={{ background: 'linear-gradient(to right, #6A8EC9 0%, #3CC6F3 100%)' }}>
                                        <img src={Icon2} className={classes.icon} alt="DQ Assessment" />
                                        <Typography variant="h6" style={{ height: '75px', color: '#fff', lineHeight: '1.1', fontWeight: 'bold' }}>
                                            Program API Key
                                        </Typography>
                                    </div>
                                    <Typography variant="body1" style={{ color: '#474747', fontSize: '14px', padding: '0 50px', marginTop: '15px' }}>
                                        Integrate your program via API to your LMS
                                    </Typography>
                                    <Button variant="contained" className={classes.button} onClick={handleOpenApiIntegration}>
                                        View
                                    </Button>
                                </CardContent>
                            </Card>
                            <ApiIntegration open={openApiIntegration} onClose={handleCloseApiIntegration} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item style={{ backgroundColor: '#fff', maxWidth: '50%', position: 'relative', padding: '10px' }}>
                    <Typography
                        variant="h6"
                        style={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                            display: 'inline-block',
                            padding: '5px 15px',
                            width: '100%',
                            background: 'linear-gradient(to right, #ED6628 0%, #FFAC46 100%)',
                            color: 'white',
                            borderRadius: '0px 0px 50px 50px',
                        }}
                    >
                        Content
                    </Typography>
                    <Grid container spacing={1}>
                        <Grid item xs={6} p={0}>
                            <Card className={classes.card}>
                                <CardContent className={classes.cardContent}>
                                    <div className={classes.cardHeader} style={{ background: 'linear-gradient(to right, #ED6628 0%, #FFAC46 100%)' }}>
                                        <img src={Icon5} className={classes.icon} />
                                        <Typography variant="h6" style={{ height: '75px', color: '#fff', lineHeight: '1.1', fontWeight: 'bold' }}>
                                            Education Materials
                                        </Typography>
                                    </div>
                                    <Typography variant="body1" style={{ color: '#474747', padding: '0 50px', fontSize: '14px', marginTop: '15px' }}>
                                        Get PDF, Word, and PowerPoint versions of your program materials
                                    </Typography>
                                    <Button variant="contained" className={classes.button} onClick={handleOpenEducationMaterial}>
                                        Download
                                    </Button>
                                </CardContent>
                            </Card>
                            <EducationMaterial open={openEducationMaterial} onClose={handleCloseEducationMaterial} onPPTDownload={generatePPTFromModules} />
                        </Grid>
                        <Grid item xs={6} p={0}>
                            <Card className={classes.card}>
                                <CardContent className={classes.cardContent}>
                                    <div className={classes.cardHeader} style={{ background: 'linear-gradient(to right, #ED6628 0%, #FFAC46 100%)' }}>
                                        <img src={Icon7} className={classes.icon} />
                                        <Typography variant="h6" style={{ height: '75px', color: '#fff', lineHeight: '1.1', fontWeight: 'bold' }}>
                                            Your Videos
                                        </Typography>
                                    </div>
                                    <Typography variant="body1" style={{ color: '#474747', padding: '0 50px', fontSize: '14px', marginTop: '15px' }}>
                                        Get your program videos as .mp4 files for easy playback
                                    </Typography>
                                    <Button variant="contained" className={classes.button} onClick={handleOpenContentVideos}>
                                        Download
                                    </Button>
                                </CardContent>
                            </Card>
                            <ContentVideos open={openContentVideos} onClose={handleCloseContentVideos} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
        </>
    )
}

export default ProgramResources